import { nanoid } from "nanoid";
import { DEFAULT_IMAGE_RELATIVE_HEIGHT } from "../../../constants";
import { loadVideoMetadata, loadImageMetadata } from "../../../helpers";
import { MediaItem } from "../../../types";

export const generateNewImage = async (
  assetId: string,
  path: string,
  previewWidth: number,
  previewHeight: number,
  newHighestLayerIndex: number
): Promise<MediaItem | undefined> => {
  if (path) {
    try {
      const {
        relativeWidth,
        relativeHeight,
        relativeCenterX,
        relativeCenterY,
      } = await loadImageMetadata(
        path,
        previewWidth,
        previewHeight,
        DEFAULT_IMAGE_RELATIVE_HEIGHT
      );

      return {
        id: nanoid(),
        assetId,
        path,
        position: { x: relativeCenterX, y: relativeCenterY },
        size: {
          width: relativeWidth,
          height: relativeHeight,
        },
        layerIndex: newHighestLayerIndex,
      };
    } catch (error) {
      console.error("Failed to load image metadata:", error);
    }
  }
};

export const generateNewVideo = async (
  assetId: string,
  path: string,
  previewWidth: number,
  previewHeight: number,
  newHighestLayerIndex: number
): Promise<MediaItem | undefined> => {
  const { relativeWidth, relativeHeight, relativeCenterX, relativeCenterY } =
    await loadVideoMetadata(path, previewWidth, previewHeight);

  const newVideoId = nanoid();

  return {
    id: newVideoId,
    assetId,
    path,
    position: { x: relativeCenterX, y: relativeCenterY },
    size: {
      width: relativeWidth,
      height: relativeHeight,
    },
    layerIndex: newHighestLayerIndex,
  };
};
